module.exports = __webpack_public_path__ + "img/Patientenablage.17f9ca0e.svg";